<script>
export default {
  name: 'SvgPreview',
	data () {
	  return {
	    msg: "Hello",
	   	template: null
	  }
	},
    render: function(createElement) {
      if (!this.template) {
        return createElement('div', {
          attrs: {
            "uk-spinner": "ratio: 3",
            "class": "uk-margin-large uk-margin-large-top"
          }
      },  ' ');
      } else {
        return this.template();
      }
    },
    mounted() {
      var self = this;
    	setTimeout(function() {
      	self.template = Vue.compile('<div>'+ self.svg + '</div>').render;
      }, 5000);
    },
    watch: {
    	svg: function () {self.template = Vue.compile('<div style="width:100%">'+ self.svg + '</div>').render}
    },
    props: ['colors', 'svg'],
}
</script>


<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/SvgPreview.vue